// this file defines both the backend api type (snake_case) and the frontend type (camelCase)
// always use AgentModelConfig (camelCase) in the frontend, and convert from
// AgentModelConfigApi at the api boundary

export interface AgentModelDefinitionApi {
    id: string
    label: string
    mention_handle: string
    group: string
    default: boolean
    aliases: string[]
}

export interface AgentModelConfigApi {
    default_model: string
    supported_models: string[]
    aliases: Record<string, string>
    models: AgentModelDefinitionApi[]
}

export type AgentModelDefinition = {
    id: string
    label: string
    mentionHandle: string
    group: string
    default: boolean
    aliases: string[]
}

export type AgentModelConfig = {
    defaultModel: string
    supportedModels: string[]
    aliases: Record<string, string>
    models: AgentModelDefinition[]
}

export function apiAgentModelConfigToCamel(api: AgentModelConfigApi): AgentModelConfig {
    return {
        defaultModel: api.default_model,
        supportedModels: api.supported_models,
        aliases: api.aliases,
        models: (api.models || []).map(model => ({
            id: model.id,
            label: model.label,
            mentionHandle: model.mention_handle,
            group: model.group,
            default: model.default,
            aliases: model.aliases,
        })),
    }
}
